import { render, staticRenderFns } from "./work-step.vue?vue&type=template&id=6207b0e8&scoped=true&"
import script from "./work-step.vue?vue&type=script&lang=js&"
export * from "./work-step.vue?vue&type=script&lang=js&"
import style0 from "./work-step.vue?vue&type=style&index=0&id=6207b0e8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6207b0e8",
  null
  
)

export default component.exports